module.exports = __webpack_public_path__ + "static/img/Todo.292f46c3.webp";